// src/services/api.js

import axios from 'axios'

const API_BASE =
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'development'
        ? 'http://127.0.0.1:8000/api'
        : 'https://admin.mojopayr.com/api')

const api = axios.create({
    baseURL: API_BASE,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    timeout: 20000,
})

api.interceptors.request.use(
    (config) => {
        const token =
            localStorage.getItem('token') ||
            localStorage.getItem('access_token')

        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }

        return config
    },
    (error) => Promise.reject(error)
)

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('access_token')
            localStorage.removeItem('session_user')

            if (window.location.pathname !== '/login') {
                const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`
                window.location.href = `/login?returnTo=${encodeURIComponent(returnTo)}`
            }
        }

        return Promise.reject(error)
    }
)

export default api
